module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPVJREFUeNqsVNENgjAQxcYB/JUfHIFOgCt0AtzAEYgb6AYyAboBToAj4A/+6gY+zGEuB20hcslLw5U+7t69EgQzxWIo2TTPHZYU2IqtEsjDcH12EoFgg6UAYk8Bd8CAsO4REUkFrEZ28wJ0R6bYRjGBJKB3i+5BMU1c7bSaGMKF5WM6+6to79HjQV9vcaW2ukg5UezRIhEtcaLvZBWJbCOQcQAioHdmaSE5Am8gE/nMVrbiXqCoSZNsirMVE5RrwOPmsUXJiU6CKGHjjjzDyKWzqxFXo2cNSKOls41lUi5bGKlRQKJroZfLpHrw0v77G5ktPgIMABwrRWEJm5P6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/appdownicon/weixinicon.png
// module id = Fhv2
// module chunks = 129